export * from './private-loction-details.web-entity';
export * from './opening-hour.web-entity';
export * from './closed-day.web-entity';
export * from './selected-product.web-entity';
export * from './selected-product-activity.web-entity';
export * from './service-hour.web-entity';
export * from './product-activity-hour.web-entity';
export * from './capacity.web-entity';
export * from './product-details.web-entity';